module.exports = __webpack_public_path__ + "img/icon_intelligent_power.ca435867.png";